import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonSlash16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPersonSlash16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.708 4.769a2.75 2.75 0 1 0-4.504 2.563A5 5 0 0 0 3 12v.477l1.04-1.04A4 4 0 0 1 7.436 8.04l1.135-1.135Q8.302 7 8 7a1.75 1.75 0 1 1 1.654-1.178zm-.86 3.683L5.3 13H12v-1a4 4 0 0 0-2.152-3.548M4.3 14l-.946.946a.5.5 0 1 1-.708-.707L12.94 3.946a.5.5 0 1 1 .707.708l-3.064 3.064A5 5 0 0 1 13 12v2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonSlash16);
